import { Grid } from '@mui/material';
import { FinalCausalityDataProps } from './props';
import { useFinalCausalityData } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';
import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';

export const FinalCausalityData = (props: FinalCausalityDataProps) => {
    const { formik, causalities, finalCausalityId } =
        useFinalCausalityData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(causalities)}
                    label="Causalidad final"
                    name="finalCausality"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.finalCausality}
                    errors={formik.errors.finalCausality}
                    value={formik.values.finalCausality}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('finalCausality', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Número causa"
                    name="causeNumber"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.causeNumber}
                    errors={formik.errors.causeNumber}
                    value={formik.values.causeNumber}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Causa real"
                    name="realCause"
                    size="small"
                    required
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.realCause}
                    errors={formik.errors.realCause}
                    value={formik.values.realCause}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Significado"
                    name="meaning"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.meaning}
                    errors={formik.errors.meaning}
                    value={formik.values.meaning}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="description"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.description}
                    errors={formik.errors.description}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                />
            </Grid>
            {finalCausalityId && (
                <Grid item xs={12} sm={4}>
                    <Checkbox
                        label="Activo"
                        checked={Boolean(formik.values.active)}
                        onChange={() =>
                            formik.setFieldValue(
                                'active',
                                !formik.values.active
                            )
                        }
                        onBlur={formik.handleBlur}
                        isCheckMode={true}
                    />
                </Grid>
            )}
        </Grid>
    );
};
